import React from "react";
import useSWR, { mutate } from "swr";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { fetcher } from "./common";
import { AssetFormDialog, AssetsTable } from "./AssetComponents";

export default function FixedAssets({ file }) {
  const listKey = `/accounting/files/${file.id}/assets`;
  const { data: assets = [] } = useSWR(listKey, fetcher);
  const { data: accounts = [] } = useSWR(`/accounting/files/${file.id}/accounts`, fetcher);
  const immoAccounts = accounts.filter((a) => /^2[0-6]/.test(a.code) && !a.code.startsWith("28") && !a.code.startsWith("29"));

  const currentYear = String(new Date().getFullYear());

  const depreciate = async (a) => {
    try {
      await api.post(`/accounting/files/${file.id}/assets/${a.id}/depreciate`);
      toast.success(`Dotation ${currentYear} comptabilisée (6813 ↔ amortissements)`);
      mutate(listKey);
    } catch (err) { toast.error(err?.response?.data?.detail || "Dotation impossible"); }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <p className="text-sm text-zinc-600 max-w-xl">Amortissement linéaire. L'acquisition et chaque dotation annuelle génèrent automatiquement leurs écritures (journal OD).</p>
        <AssetFormDialog file={file} immoAccounts={immoAccounts} listKey={listKey} />
      </div>
      <AssetsTable assets={assets} currentYear={currentYear} onDepreciate={depreciate} />
    </div>
  );
}
